<template>
    <div class="scheme">
        <div class="mbx clearfix">
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服服务</el-breadcrumb-item>
                <el-breadcrumb-item>企业信息</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="fr" @click="addSchemeDialogVisible = true">添加</el-button>
            <!-- 新增弹窗 -->
            <el-dialog title="新增企业资讯" :visible.sync="addSchemeDialogVisible" width="50%" center>
                <el-form :model="shemeForm" :rules="rules" ref="shemeForm">
                    <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="服务对象" prop="serviceObject" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.serviceObject"></el-input>
                    </el-form-item>
                    <el-form-item label="企业行业" prop="companyIndustry" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.companyIndustry"></el-input>
                    </el-form-item>
                    <el-form-item label="企业规模" prop="companyScale" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.companyScale"></el-input>
                    </el-form-item>
                    <el-form-item label="常用服务" prop="oftenService" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.oftenService"></el-input>
                    </el-form-item>
                    <el-form-item label="合作目的" prop="cooperationPurpose" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.cooperationPurpose"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="addSchemeDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addScheme('shemeForm')">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <!-- 表格 -->
        <el-table :data="tableData.list" border style="width: 100%">
            <el-table-column prop="customerServiceId" label="关联ID" width="80">
            </el-table-column>
            <el-table-column prop="title" label="标题" width="200">
            </el-table-column>
            <el-table-column prop="serviceObject" label="服务对象" width="150">
            </el-table-column>
            <el-table-column prop="companyIndustry" label="企业行业" width="120">
            </el-table-column>
            <el-table-column prop="companyScale" label="企业规模" width="120">
            </el-table-column>
            <el-table-column prop="oftenService" label="常用服务" width="400">
            </el-table-column>
            <el-table-column prop="cooperationPurpose" label="合作目的" width="400">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="updateDateil(scope.row)" type="text" size="small">详情</el-button>
                    <el-button @click="amendClick(scope.row)" type="text" size="small">修改</el-button>
                    <el-button v-if="scope.row.customerServiceStatus !== 1" type="text" @click="alterState(1,scope.row)" size="small">发布</el-button>
                    <el-button v-if="scope.row.customerServiceStatus !== 2" type="text" @click="alterState(2,scope.row)" size="small">下架</el-button>
                    <el-button v-if="scope.row.customerServiceStatus !== 3" type="text" @click="alterState(3,scope.row)" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination v-model="tableData" @current-change="handleCurrentChange" :current-page.sync="tableData.pageNum" layout="total, prev, pager, next, jumper" :total="tableData.total">
            </el-pagination>
        </div>
        <!-- 修改的弹窗 -->
        <el-dialog title="修改解决方案" :visible.sync="amendSchemeDialogVisible" width="50%" center>
            <el-form :model="shemeAmendForm" :rules="rules" ref="shemeAmendForm">
                <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.title"></el-input>
                </el-form-item>
                <el-form-item label="服务对象" prop="serviceObject" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.serviceObject"></el-input>
                </el-form-item>
                <el-form-item label="企业行业" prop="companyIndustry" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.companyIndustry"></el-input>
                </el-form-item>
                <el-form-item label="企业规模" prop="companyScale" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.companyScale"></el-input>
                </el-form-item>
                <el-form-item label="常用服务" prop="oftenService" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.oftenService"></el-input>
                </el-form-item>
                <el-form-item label="合作目的" prop="cooperationPurpose" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.cooperationPurpose"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="amendSchemeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="amendScheme('shemeAmendForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { customerService, addCustomerService, updateCustomerService } from '../api/api.js'
    export default {
        name: 'serverInfo',
        created() {
            customerService().then((res) => {
                this.tableData = res.data.data;
            })
        },
        data() {
            return {
                tableData: [],
                shemeForm: {},
                shemeAmendForm: {},
                addSchemeDialogVisible: false,
                amendSchemeDialogVisible: false,
                formLabelWidth: '100px',
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                    companyIndustry: [
                        { required: true, message: '请输入企业行业', trigger: 'blur' }
                    ],
                    companyScale: [
                        { required: true, message: '请输入企业规模', trigger: 'blur' }
                    ],
                    cooperationPurpose: [
                        { required: true, message: '请输入合作目的', trigger: 'blur' }
                    ],
                    oftenService: [
                        { required: true, message: '请输入常用服务', trigger: 'blur' }
                    ],
                    serviceObject: [
                        { required: true, message: '请输入服务对象', trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            // 详情编辑
            updateDateil(json) {
                this.$router.push({ path: '/ht_customCase', query: { khId: json.customerServiceId } });
            },
            // 修改点击
            amendClick(param) {
                this.amendSchemeDialogVisible = true;
                this.shemeAmendForm = param;
            },
            amendScheme() {
                let data = {
                    companyIndustry: this.shemeAmendForm.companyIndustry,
                    companyScale: this.shemeAmendForm.companyScale,
                    cooperationPurpose: this.shemeAmendForm.cooperationPurpose,
                    customerServiceId: this.shemeAmendForm.customerServiceId,
                    customerServiceStatus: this.shemeAmendForm.customerServiceStatus,
                    oftenService: this.shemeAmendForm.oftenService,
                    serviceObject: this.shemeAmendForm.serviceObject,
                    title: this.shemeAmendForm.title,
                }
                updateCustomerService(data).then(res => {
                    if (res.status === 1) {
                        this.amendSchemeDialogVisible = false;
                        this.$message({
                                message: '修改成功',
                                type: 'success'
                            }),
                            this.shemeAmendForm = {};
                        customerService().then((res) => {
                            this.tableData = res.data.data;
                        })
                    }
                })
            },
            // 添加点击
            addScheme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        addCustomerService(this.shemeForm).then((res) => {
                            if (res.status === 1) {
                                this.addSchemeDialogVisible = false;
                                this.$refs[formName].resetFields();
                                this.$message({
                                        message: '添加成功',
                                        type: 'success'
                                    }),
                                    customerService().then((res) => {
                                        this.tableData = res.data.data;
                                    })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                this.addSchemeDialogVisible = false
            },
            handleRemove(file, fileList) {
                this.$message.warning(`成功删除文件，请重新选取文件`);
                this.shemeForm.companyNewsImg = '';
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 上传图片
            uploadSuccedd(file) {
                this.shemeForm.companyNewsImg = file.data.filePath;
                this.shemeAmendForm.companyNewsImg = file.data.filePath;
            },
            // 分页
            handleCurrentChange(val) {
                customerService({ pageNum: val }).then((res) => {
                    this.tableData = res.data.data;
                })
            },
            // 修改状态
            alterState(state, json) {
                let message = '';
                switch (state) {
                case 1:
                    message = '发布'
                    break;
                case 2:
                    message = '下架'
                    break;
                case 3:
                    message = '删除'
                    break;
                }
                this.$confirm('确定要' + message + '？', '提示', {
                    type: 'warning'
                }).then(() => {
                    let data = {
                        customerServiceStatus: state,
                        customerServiceId: json.customerServiceId
                    }
                    updateCustomerService(data).then(res => {
                        if (res.status === 1) {
                            this.$message({
                                    message: message + '成功',
                                    type: 'success'
                                }),
                                customerService().then((res) => {
                                    this.tableData = res.data.data;
                                })
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .mbx {
        background-color: #f5f5f5;
        padding: 1% 4%;
    }

    .block {
        float: right
    }
</style>



// WEBPACK FOOTER //
// src/components/ht_serverInfo.vue